import { styled } from '@mui/system'
import { colors, fontSizes } from '../../Components/consts'

export const AcademyGamedayEventCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  margin: theme.spacing(4, 1),
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(10, 1, 2),
  },
  '& img': {
    background: colors.gray.gray20,
    borderRadius: 6,
    width: 199,
      height: 112,
      margin: theme.spacing(1, 2),
  },
  '& .infoCon': {
    margin: theme.spacing(1, 2, 2.5),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    '& .upper': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      marginTop: theme.spacing(0.5),
      '& .date': {
        fontSize: fontSizes.small,
        fontWeight: 800,
        color: colors.gray.gray80,
      },
      '& .location': {
        fontWeight: 600,
        fontSize: fontSizes.medium,
        color: colors.gray.gray80
      },
    },
    '& .athCon': {
      '& p': {
        fontSize: fontSizes.small,
        color: colors.gray.gray80,
        margin: '8px 0 3px',
      },
      '& .athName': {
        fontWeight: 500,
        fontSize: fontSizes.small,
        color: colors.gray.gray70
      }
    },
    '& .register': {
      marginTop: theme.spacing(2),
      color: colors.blue,
      fontSize: fontSizes.small,
      fontWeight: 600,
      textDecoration: 'none',
    }
  },

  
}))
